import type {CustomerWork} from './schemas'

type SiteHint = {name: string; fromSavedLocationId: string | null}

function normalizeSiteName(name: string) {
    return name.trim().toLowerCase()
}

function isSameSite(work: CustomerWork, sites: SiteHint[]): boolean {
    const names = new Set(work.siteNames.map(normalizeSiteName))
    return sites.some(
        (site) =>
            (site.fromSavedLocationId != null &&
                work.savedLocationIds.includes(site.fromSavedLocationId)) ||
            (site.name.trim() !== '' && names.has(normalizeSiteName(site.name))),
    )
}

export function workOptionLabel(work: CustomerWork): string {
    const jobs = `${work.jobs.length} ${work.jobs.length === 1 ? 'job' : 'jobs'}`
    return [work.name, work.orderNumber, jobs].filter(Boolean).join(' · ')
}

export function openWorkAtSameSite(work: CustomerWork[], sites: SiteHint[]): CustomerWork | null {
    return work.find((item) => item.isOpen && item.canAddJob && isSameSite(item, sites)) ?? null
}

export function othersOpenWorkAtSameSite(work: CustomerWork[], sites: SiteHint[]): CustomerWork[] {
    return work.filter((item) => item.isOpen && !item.canAddJob && isSameSite(item, sites))
}

export function othersOpenWorkMessage(works: CustomerWork[], also: boolean): string {
    const named = works.map(
        (work) => `${work.repName ?? 'another rep'} (${work.orderNumber ?? work.name})`,
    )
    const owners =
        named.length > 1
            ? `${named.slice(0, -1).join(', ')} and ${named[named.length - 1]}`
            : named[0]
    const what =
        works.length > 1
            ? `There are ${also ? 'also ' : ''}open orders`
            : `There is ${also ? 'also ' : ''}an open order`
    return `${what} at this site from ${owners}. Ask them or a manager to add this job.`
}
